import { motion } from "framer-motion";
import { ArrowUpRight } from "@phosphor-icons/react";
import { useSeo } from "../lib/seo";
import { FILMS } from "../lib/data";

export default function Films() {
  useSeo({
    title: "Shaji Nada | Films & Productions — Filmography",
    description:
      "Filmography of Shaji Nada — producer of She Came Back, Galaxy Built on Hope, 99 Songs (with A.R. Rahman), and LeMusk.",
    canonicalPath: "/films",
  });

  return (
    <div data-testid="films-page" className="pt-32 md:pt-40 pb-24">
      <section className="max-w-[1600px] mx-auto px-6 md:px-12">
        <p className="overline mb-6">Filmography</p>
        <h1 className="font-serif-display text-5xl md:text-7xl lg:text-8xl text-white leading-[0.98] max-w-5xl" data-testid="films-h1">
          Stories rooted in <span className="italic text-[var(--accent)]">place.</span> Built to travel.
        </h1>
      </section>

      <section className="mt-20 md:mt-28 max-w-[1600px] mx-auto px-6 md:px-12 grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-8">
        {FILMS.map((f, idx) => (
          <motion.a
            key={f.title}
            href={f.imdb}
            target="_blank"
            rel="noopener noreferrer"
            data-testid={`film-card-${idx}`}
            initial={{ opacity: 0, y: 30 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true, margin: "-60px" }}
            transition={{ duration: 0.7, delay: idx * 0.08 }}
            className="group block"
          >
            <div className="relative aspect-[2/3] overflow-hidden bg-[#1A1A1A]">
              <img
                src={f.poster}
                alt={`${f.title} (${f.year}) — produced by Shaji Nada`}
                loading="lazy"
                className="w-full h-full object-cover transition-transform duration-[1.4s] ease-out group-hover:scale-105"
                style={f.posterPosition ? { objectPosition: f.posterPosition } : undefined}
              />
              <div className="absolute inset-0 bg-gradient-to-t from-black/90 via-black/30 to-transparent opacity-90 group-hover:opacity-100 transition-opacity" />
              <div className="absolute inset-0 p-6 flex flex-col justify-end">
                <p className="overline mb-2">{f.year} · {f.role}</p>
                <h3 className="font-serif-display text-3xl text-white">{f.title}</h3>
                <p className="mt-3 text-sm text-white/70 font-light leading-relaxed line-clamp-3 group-hover:line-clamp-none">
                  {f.synopsis}
                </p>
                <span className="mt-4 inline-flex items-center gap-2 text-[var(--accent)] uppercase tracking-[0.22em] text-[10px]">
                  IMDb <ArrowUpRight size={12} />
                </span>
              </div>
            </div>
          </motion.a>
        ))}
      </section>
    </div>
  );
}
